import { useState } from "react";
import { startCheckout } from "@/lib/checkout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Globe, Layers } from "lucide-react";
import { parseRemaining } from "./data";
import { CouponField } from "./CouponField";

export function ShopResi({ accounts }) {
  const [gb, setGb] = useState(10);
  const [coupon, setCoupon] = useState(null);
  const acc = accounts[0];
  const remaining = acc ? parseRemaining(acc.remote) : null;
  const base = gb * 6;
  const discount = coupon ? (coupon.percent_off ? base * coupon.percent_off / 100 : Math.min(coupon.amount_off || 0, base)) : 0;
  const final = Math.max(base - discount, 0);
  return (
    <div className="space-y-6">
      <div className="led-border bg-white border border-[#E4EEEC] rounded-3xl p-6 shadow-sm">
        <div className="flex items-center gap-2 mb-1"><Globe className="w-5 h-5 text-neon" aria-hidden="true" /><h3 className="font-head text-xl font-semibold text-ink">Residential Bandwidth</h3></div>
        <p className="text-zinc-500 text-sm mb-5">$6 / GB · rotating & sticky · data never expires · delivered instantly.</p>
        <div className="flex flex-wrap items-center gap-3">
          <Input type="number" min={1} value={gb} onChange={(e) => setGb(Math.max(1, Number(e.target.value)))} className="w-28 h-11 bg-white border-[#E4EEEC] focus:border-neon rounded-xl font-mono text-ink" data-testid="gb-amount-input" />
          <span className="text-zinc-500 text-sm font-mono" data-testid="resi-price-display">GB · {coupon
            ? (<><span className="line-through text-zinc-400">${base.toFixed(2)}</span> <span className="text-neon text-lg">${final.toFixed(2)}</span></>)
            : (<span className="text-neon text-lg">${base.toFixed(2)}</span>)}</span>
          <Button onClick={() => startCheckout({ product: "residential_gb", quantity: gb, promotion_code: coupon?.code })} className="bg-neon text-white hover:bg-neon-hover font-semibold rounded-xl" data-testid="buy-residential-button">Buy {gb} GB · ${final.toFixed(0)}</Button>
        </div>
        <div className="mt-4"><CouponField product="residential_gb" quantity={gb} onChange={setCoupon} /></div>
        <p className="text-xs text-zinc-400 mt-4">No setup required — your proxies are provisioned automatically right after checkout and are ready to generate on the dashboard.</p>
      </div>
      {acc && (
        <div className="led-border bg-white border border-[#E4EEEC] rounded-3xl p-6 shadow-sm" data-testid="resi-plan-card">
          <div className="flex items-center gap-2 mb-4"><Layers className="w-5 h-5 text-neon" aria-hidden="true" /><h3 className="font-head text-lg font-semibold text-ink">Your residential plan</h3></div>
          <div className="grid sm:grid-cols-2 gap-4">
            <div><div className="text-xs text-zinc-400">Proxy username</div><div className="font-mono text-neon">{acc.username}</div></div>
            <div><div className="text-xs text-zinc-400">Bandwidth remaining</div><div className="font-mono text-ink">{remaining != null ? `${remaining} GB` : "—"}</div></div>
          </div>
        </div>
      )}
    </div>
  );
}
